module.exports = __webpack_public_path__ + "img/_map_en_montreal.1f445345.jpg";